module.exports = __webpack_public_path__ + "img/es-ca.a35e6a4a.svg";